<template>
  <v-switch
    flat
    v-bind="$attrs"
    v-on="$listeners"
    @click="(v) => $emit('click', v)"
  />
</template>

<script>
/**
 * @fileoverview Common component for toggle switches
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */
export default {
  name: "Toggle",
  props: {},
};
</script>

<style lang="scss" scoped>
.v-input {
  &::v-deep {
    .v-input--selection-controls__input {
      height: 30px;
      width: 57px;
    }
    .v-input--selection-controls__ripple {
      left: -7px;
      top: calc(50% - 16px);
    }
    .v-input--switch__track {
      color: $qvo-color-grey-300;
      height: 100%;
      width: 100%;
      border-radius: 15px;
      opacity: 1;
      transition: color .2s ease-in;
    }
    .v-input--switch__thumb {
      top: calc(50% - 4px);
      height: 24px;
      width: 24px;
      left: 5px;
    }
  }
}
.v-input.v-input--is-label-active {
  &::v-deep {
    .v-input--switch__thumb,
    .v-input--selection-controls__ripple {
      transform: translate(27px);
    }
    .v-input--switch__track {
      color: $qvo-color-blue-400;
    }
  }
}
.v-input--switch.v-input.v-input--is-disabled {
  &::v-deep {
    .v-input--switch__track {
      color: $qvo-color-grey-100 !important; // Vuetify uses !important here to set the disabled background color 🤦
    }
  }
}
</style>